import { render, staticRenderFns } from "./success.vue?vue&type=template&id=b4077252&scoped=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"
import style0 from "./success.vue?vue&type=style&index=0&id=b4077252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4077252",
  null
  
)

export default component.exports